import { createReducer } from '@reduxjs/toolkit';
import { getContactRecordsByEmail } from '../actions/crmObjects';
const initialState = {};
export const crmObjects = createReducer(initialState, builder => {
  builder.addCase(getContactRecordsByEmail.fulfilled, (state, action) => {
    return Object.assign({}, state, action.payload.objects);
  });
});